import { render, staticRenderFns } from "./ReplaceCardDetails.vue?vue&type=template&id=18b7620c&scoped=true&"
import script from "./ReplaceCardDetails.vue?vue&type=script&lang=js&"
export * from "./ReplaceCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceCardDetails.vue?vue&type=style&index=0&id=18b7620c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b7620c",
  null
  
)

export default component.exports